// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KAX6K","inner":"Footer_inner__2ccex"};